import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Calendar} from 'primeng/calendar';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'w-date-field',
  templateUrl: './date-field.component.html',
  styleUrls: ['./date-field.component.scss']
})
export class DateFieldComponent implements OnInit, OnChanges {

  @Input() label: string;
  @Input() hideLabel: boolean = false;
  @Input() value: Date;

  @Output() valueChange: EventEmitter<Date> = new EventEmitter<Date>();

  @ViewChild('calendar', {static: false}) calendar: Calendar;

  stringValue: string;

  constructor(private loggingService: LoggerService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.value = changes.value.currentValue;
    if (this.value) {
      this.stringValue = this.value.toLocaleDateString();
    } else {
      this.stringValue = undefined;
    }
  }


  dateHandler() {
    const input = this.calendar.el.nativeElement;
    const actualInput = input.getElementsByTagName('input')[0];

    const hours = this.value.getHours();
    const minutes = this.value.getMinutes();
    const time = hours + ':' + minutes;

    if (!this.value && (!actualInput.value || actualInput.value.length === 0)) {
      return;
    }

    if (!this.stringValue) {
      this.stringValue = actualInput.value;
    } else {
      // primeng calendar parsed the date successfully
      return;
    }

    const split = this.stringValue.split('/');
    const howManyValues = split.length;

    // if (!this.stringValue) {
    //   this.stringValue = new Date().getMonth() + 1 + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    // }

    switch (howManyValues) {


      case 1:

        // x
        if (split[0].length === 1) {
          const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
          this.stringValue = month + '/' + '0' + split[0] + '/' + new Date().getFullYear();
        }
        if (split[0].length === 2) {
          const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
          this.stringValue = month + '/' + '0' + split[0] + '/' + new Date().getFullYear();
        }
        break;

      case 2:

        if (split[0].length === 1){
          split[0] = '0' + split[0];
        }

        if (split[1].length === 1){
          split[1] = '0' + split[1];
        }

        this.stringValue = split[0] + '/' + split[1] + '/' + new Date().getFullYear();
        break;

      case 3:

        // x/xx/xxxx
        if (split[0].length === 1 && split[1].length === 2 && split[2].length === 4) {
          split[0] = '0' + split[0];
          this.stringValue = split[0] + '/' + split[1] + '/' + split[2];
        }

        // x/x/xx
        if (split[0].length === 1 && split[1].length === 1 && split[2].length === 2) {
          split[0] = '0' + split[0];
          split[1] = '0' + split[1];
          const yearSubstr = new Date().getFullYear().toString().substr(0, 2);
          this.stringValue = split[0] + '/' + split[1] + '/' + yearSubstr + split[2];
        }

        // x/xx/xx
        if (split[0].length === 1 && split[1].length === 2 && split[2].length === 2) {
          split[0] = '0' + split[0];
          const yearSubstr = new Date().getFullYear().toString().substr(0, 2);
          this.stringValue = split[0] + '/' + split[1] + '/' + yearSubstr + split[2];
        }

        // xx/x/xxxx
        if (split[0].length === 2 && split[1].length === 1 && split[2].length === 4) {
          split[1] = '0' + split[1];
          this.stringValue = split[0] + '/' + split[1] + '/' + split[2];
        }
    }

    const regexDateExp = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

    if (regexDateExp.test(this.stringValue)) {
      this.value = new Date(this.stringValue + ' ' + time);
      this.valueChange.emit(this.value);
      this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.DateFieldComponent, 'Selected date : ' + this.value);
    } else {
      const newDate = new Date();
      this.valueChange.emit(newDate);
      this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.DateFieldComponent, 'Selected date : ' + newDate);
    }
  }

  calendarFocus() {
    // at the time of writing this, there was a bug with primeng calendar, which required two tab presses
    // for tabbing into the date input, so I had to manually select the input inside the component for tabbing with this event

    const input = this.calendar.el.nativeElement;
    const actualInput = input.getElementsByTagName('input')[0];

    actualInput.focus();
    actualInput.select();
  }

  dateSelect($event: Date) {
    const hours = this.value.getHours();
    const minutes = this.value.getMinutes();
    $event.setHours(hours, minutes, 0);
    this.value = $event;
    this.valueChange.emit(this.value);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.DateFieldComponent, 'Selected date : ' + this.value);
  }
}
